/**
 * Convierte un número de mes (1-12) al nombre del mes
 * @param {number} monthNumber - Número del mes (1-12)
 * @returns {string} Nombre del mes
 */
export const getMonthName = (monthNumber) => {
    const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    // Validar que el número esté en el rango correcto (1-12)
    if (monthNumber >= 1 && monthNumber <= 12) {
        return months[monthNumber - 1];
    }
    
    return '';
}

/**
 * Obtiene el número del mes actual (1-12)
 * @returns {number} Número del mes actual
 */
export const getCurrentMonthNumber = () => {
    return new Date().getMonth() + 1;
}

/**
 * Obtiene el año actual
 * @returns {number} Año actual
 */
export const getCurrentYear = () => {
    return new Date().getFullYear();
}

/**
 * Obtiene el nombre del mes actual
 * @returns {string} Nombre del mes actual
 */
export const getCurrentMonthName = () => {
    return getMonthName(getCurrentMonthNumber());
}

